import React, { Children, cloneElement, isValidElement, ReactElement } from 'react';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';
import { BucketLogData } from '@bucketplace/bucket-log';

import { EditorPlaceholder } from '../../../components';
import { DocumentNode } from '../../../types';

export interface StickyTabItemProps {
  /** 각 탭의 id. 앵커링 타겟 id와 동일한 id */
  id?: string;
  children: DocumentNode[];
  logData?: BucketLogData;
  /** 탭 item click시 호출됩니다.
   * @param tabId click한 탭 id
   */
  onClick: (tabId: string) => void;
}

export function StickyTabItem({ id, children, logData, onClick }: StickyTabItemProps): ReactElement {
  if (!id || id.length === 0) {
    return (
      <EditorPlaceholder
        icon={<BsPlus />}
        message="탭 아이템 id를 입력해주세요."
      />
    );
  }

  return (
    <>
      { Children.map(children, (child) => {
        if (!isValidElement(child)) { return child; }
        return cloneElement(child, { id, logData, onClick });
      }) }
    </>
  );
}
